import React from "react";
import { Link } from "react-router-dom";
import "../styles/Services.css";
import imgone from "../../../images/img-one.jpg";
import imgtwo from "../../../images/img-two.jpg";
import imgthree from "../../../images/img-three.jpg";

const Services = () => {
  return (
    <div>
      <section className="services__section" id="services">
        <div className="container">
          <div className="row">
            <div className="faq-content">
              <h2
                className="h2-title"
                style={{ textAlign: "center", fontSize: "24px" }}
              >
                OUR SERVICES
              </h2>
            </div>
          </div>
          <div className="card card-body card__body">
            <div className="row align-items-center">
              <div className="col-md-5 mt-1 mb-1">
                <div className="partner__content text-left p-5">
                  <h3 className="pt-3">RETIREMENT INSURANCE</h3>
                  <p className="pt-2">
                    Retirement insurance plan is the bedrock of insurance
                    planning that enables you prepare ahead to secure your
                    future life after paid work ends.
                  </p>
                  <p className="text-end">
                    <Link to="#">Learn more</Link>
                  </p>
                </div>
              </div>
              <div className="col-md-7">
                <div className="service-img">
                  <img
                    src={imgone}
                    className="img-fluid"
                    alt="Life Insurance"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card card-body card__body">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="service-img">
                  <img
                    src={imgtwo}
                    className="img-fluid"
                    alt="Content Insurance"
                  />
                </div>
              </div>
              <div className="col-md-5 pt-1 pb-1">
                <div className="partner__content text-left p-5 ">
                  <h3 className="pt-3">CONTENT INSURANCE</h3>
                  <p className="pt-2">
                    Contents insurance is an insurance policy that pays for
                    damage to, or loss of, an individuals possessions while they
                    are located within that individual.
                  </p>
                  <p className="text-end">
                    <Link to="#">Learn more</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card card-body  card__body">
            <div className="row align-items-center">
              <div className="col-md-5 pt-1 pb-1">
                <div className="partner__content text-left p-5">
                  <h3 className="pt-3">PRODUCT LIABILITY INSURANCE</h3>
                  <p className="pt-2">
                    Product liability insurance is an insurance policy that
                    offers financial protection over your product.
                  </p>
                  <p className="text-end">
                    <Link to="#">Learn more</Link>
                  </p>
                </div>
              </div>
              <div className="col-md-7">
                <div className="service-img">
                  <img
                    src={imgthree}
                    className="img-fluid"
                    alt="Life Insurance"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className="text-center">
          <Link to="#">See more...</Link>
        </p>
      </section>
    </div>
  );
};

export default Services;
